import {LOADER_STATUS} from './actionTypes';

export const loaderStatus = (value) => dispatch => {
    dispatch({
        type: LOADER_STATUS,
        payload: value,
    })
}